import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export type QBConnectionStatus = {
  connected: boolean;
  hasAccessToken: boolean;
  hasRefreshToken: boolean;
  hasRealmId: boolean;
  redirectUri: string;
  frontendSuccessUrl: string;
  message: string;
};

export type QBReconnectUrlResponse = {
  authorizationUrl: string;
  redirectUri: string;
};

export type QBUnsentItem = {
  kind: "FormInvoice" | "MemberCustomer" | string;
  id: number;
  title: string;
  companyName?: string | null;
  submittedBy?: string | null;
  date?: string | null;
  amount?: number | null;
  lastError?: string | null;
  reason: string;
  formId?: number | null;
  memberId?: number | null;
};

export type QBResubmitResult = {
  success: boolean;
  kind: string;
  id: number;
  message: string;
  quickBooksId?: string | null;
};

class QBApi {
  static getStatus() {
    return axios.get<QBConnectionStatus>(
      `${API_URL}/api/qb/status`,
      getAuthHeader()
    );
  }

  static getReconnectUrl() {
    return axios.get<QBReconnectUrlResponse>(
      `${API_URL}/api/qb/reconnect-url`,
      getAuthHeader()
    );
  }

  static getUnsent() {
    return axios.get<QBUnsentItem[]>(`${API_URL}/api/qb/unsent`, getAuthHeader());
  }

  static resubmit(kind: string, id: number) {
    return axios.post<QBResubmitResult>(
      `${API_URL}/api/qb/resubmit/${encodeURIComponent(kind)}/${id}`,
      {},
      getAuthHeader()
    );
  }

  static resubmitAll() {
    return axios.post<QBResubmitResult[]>(
      `${API_URL}/api/qb/resubmit-all`,
      {},
      getAuthHeader()
    );
  }
}

export default QBApi;
